export default __webpack_public_path__ + "static/media/icon3.61805d0f.svg";